import { BoundTextEditor } from "minimals-template/components/editor"

/**
 * Recipient input for a `richText` requested field. Rich-text editor bound to `values.<field.id>`.
 *
 * @param {object} props
 * @param {{ id: string }} props.field
 */
export function RichTextFieldInput({ field }) {
    // noLabel: the host (requested-field-input) already shows the field's label, and without this the
    // editor auto-generates a label from the bound path ("values.<id>"), leaking the field id.
    return <BoundTextEditor field={`values.${field.id}`} noLabel />
}
